import Flickity from 'flickity';

class Stories {
	constructor(node) {
		this.node = node;
		this.wrap = this.node.querySelector('.stories__items');
		this.items = Array.from(this.wrap.querySelectorAll('.stories__item'));

		this.flickity = new Flickity(this.wrap, {
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'left',
			imagesLoaded: true,
			prevNextButtons: false,
			watchCSS: true,
			wrapAround: false
		});
	}
}

export default Stories;
